import { SearchTerm } from './SearchTerm';

const DeviceImproxSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "devName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
    {
        heading: "Type",
        accessor: "unitType",
        searchOnName: "unitType.utName",
        translationKey: "type"
    }
];

export default DeviceImproxSearch;
